/**
 * PLEASE DON'T EDIT THIS FILE
 * @author RCS Group S.p.A
 */

import load from 'little-loader';
import config from 'config';

try {
  let scripts = config.externals;
  scripts.forEach(file => {
    if (typeof window[file.var] === 'undefined') {
      load(file.src);
    }
  });
} catch (e) {}



// WEBPACK FOOTER //
// ./external-loader.js